/**
 * @generated SignedSource<<abde70c62d8426268d1637ea90503342>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordToggle_viewer$data = {
  readonly meetingRecapAutoShareSettings: {
    readonly sendTo: UserMeetingRecapSendTo;
  } | null;
  readonly " $fragmentType": "AutoRecordToggle_viewer";
};
export type AutoRecordToggle_viewer$key = {
  readonly " $data"?: AutoRecordToggle_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordToggle_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMeetingRecapAutoShareSettings",
      "kind": "LinkedField",
      "name": "meetingRecapAutoShareSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendTo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "68a05cdb0c4b7e3f113c44a4e211078f";

export default node;
